module.exports = __webpack_public_path__ + "static/img/msp2.3333259.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/msp2.png
// module id = TgW/
// module chunks = 0